<template>
  <div class="welcome">
    <p class="welcome-title">{{ date | toTimeRange() }}{{ nickname }}</p>
    <div class="welcome-bd">
      <div class="welcome-date">
        <div class="time">{{ date | formatTimestamp('HH:mm', false, true) }}</div>
        <div class="date">
          {{ date | formatTimestamp('MM-dd', false, true) }}
          {{ date | formatTimestamp('whichDay') }}
        </div>
      </div>
      <div class="region">{{region}}</div>
      <div class="welcome-weather">
        <div class="temp">{{ temp }}°C</div>
        <div class="weather">{{ weather }}</div>
      </div>
    </div>
     <div class="welcome-last-login">{{ lastLogin }}</div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { getLastLogin, getWeather } from '@/api/sign';
  import { formatTimestamp } from '@/filters';

  export default {
    name: 'Welcome',
    data() {
      return {
        weatherInfo: '',
        weatherVisible: '',
        lastLogin: '',
        temp: 0,
        weather: '',
        region: ''
      };
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'avatar',
      ]),
      date() {
        return new Date();
      },
      nickname() {
        let nickname = '';
        if (this.userInfo && this.userInfo.accounts) {
          const { user, accounts } = this.userInfo;
          const { gender } = user;
          const [account] = accounts;
          const { identityTypeCode } = account;
          switch (identityTypeCode) {
            case 'teacher':
              nickname = account.userName.charAt(0) + '老师';
              break;
            case 'student':
              nickname = account.userName.charAt(0) + '同学';
              break;
            case 'visitor':
              nickname = account.userName;
              break;
            default:
              nickname = account.userName;
              break;
          }
        }
        return nickname;
      },
    },
    created() {
      this.handleGetWeather();
      //this.handLastLogin();
    },
    methods: {
      //获取上次登录时间
      handLastLogin() {
        getLastLogin().then((res) => {
         const addTime = res.data && res.data.items && res.data.items.length > 0 ? res.data.items[0].addTime : '';
          if(!addTime) {
            return '';
          }
          this.lastLogin = '最近登录时间:' + formatTimestamp(addTime, 'yyyy-MM-dd HH:mm:ss');
        });
      },
      // 获取天气
      handleGetWeather() {
        getWeather().then((res) => {
          const { temp, text } = res.data.result.now;
          this.temp = temp;
          this.weather = text;
          this.region = res.data.result.location.name;
        });
      },
    },
  };
</script>
<style lang="scss">
  .welcome {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 348px;
    padding-right: 50px;
    padding-left: 50px;

    &-title {
      padding-bottom: 30px;
      font-size: 48px;
      //white-space:nowrap;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      line-height: 60px;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 4px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.39);
    }

    &-bd {
      display: flex;
      justify-content: space-between;
      padding-top: 30px;
      padding-right: 65px;
      align-items: flex-end;
    }

    &-date,
    &-weather {
      display: flex;
      flex-direction: column;
    }

    .time,
    .temp {
      height: 38px;
      font-size: 38px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      line-height: 38px;
      color: rgba(255, 255, 255, 1);
    }

    .date,
    .weather {
      height: 16px;
      margin-top: 20px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      line-height: 16px;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 1px;
    }
    .region {
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
    &-last-login {
      height: 16px;
      margin-top: 30px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      line-height: 16px;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 1px;
    }

  }
</style>
